export default {
    read: function(response = {}) {
        response.l_name = response.client_data?.l_name || '';
        response.f_name = response.client_data?.f_name || '';
        response.m_name = response.client_data?.m_name || '';
        response.fio = `${response.l_name || ''} ${response.f_name || ''} ${response.m_name || ''}`;
        return response;
    },
};
